<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import minhead from "../../../../common/minHead/index.vue";
import {
    getAnalysusDetailPageListBySet,saveSetDetail,updateSetDetail,deleteSetDetail
} from '../../../../../api/contrastSetting.js';
export default {
  name: "dbmxx",
  components: {minhead},
  data() {
    return {
      tablekey: 0,
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      searchdiag: false,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      sort: "",
      order: "",
      tableData: [],
      ywdiag: false,
      ywtitle: "",
      relations: [],
      sourceFlagData:[],
      formlist: getdata().formlist,
      formdata: getdata().formdata,
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    mxShuizId: {
      type: String,
      default: "",
    },
    mxShuizName: {
      type: String,
      default: "",
    },
    nameDesc: {
      type: String,
      default: "",
    },
	  ywdiags: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
	ywdiags:function(indexVal, oldVal) {
		if(indexVal == true){
			this.getAnalysusDetailPageListBySet();
		}else{
			Object.keys(this.searchdata).map(key=>{
				this.searchdata[key] = ''
			})
		}
    },
  },
  created() {
  },
  mounted() {
	 
  },
  methods: {
	  selectchange(e){
		  
	  },
	  resetClickFun(){
		 this.searchlist =getdata().searchlist
	  },
    /* 新增/编辑 */
    closediag() {
      this.ywdiag = false;
    },
    saveSetDetail() {
      let params = JSON.parse(JSON.stringify(this.formdata))
      params.settingId = this.id;
      params.shuizId = this.mxShuizId;
      params.enableFlag = params.enableFlag ? "1" : "0";
      console.log(params)
      if (this.ywtitle == "新增对比明细项") {
        saveSetDetail(params).then((res) => {
          if (res.data.code === "1") {
            this.$message.success("保存成功!");
            this.ywdiag = false;
            this.getAnalysusDetailPageListBySet();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        updateSetDetail(params).then((res) => {
          if (res.data.code === "1") {
            this.$message.success("保存成功!");
            this.ywdiag = false;
            this.getAnalysusDetailPageListBySet();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    forUpdateSetDetail(row) {
      this.ywtitle = "编辑对比明细项";
      this.ywdiag = true;
      this.formdata = row;
      this.formdata.enableFlag = row.enableFlag === "1" ? true : false;
    },
    forAddSetDetail() {
      this.formdata = {enableFlag: true};
      this.ywtitle = "新增对比明细项";
      this.ywdiag = true;
    },
    setDetailDelete() {
        let checkRow = this.$refs.tablebox.getSelectionval();
        if (checkRow && checkRow.length > 0) {
            this.$showConfirm({
                message: '确认删除?'
            }).then(res => {
                if (res === 'confirm') {
                    let checkIds = checkRow.map(item => item.id);
                    let params = {idList: checkIds}
                    deleteSetDetail(params).then((res) => {
                        if (res.data.code === "1") {
                            this.$message.success("删除成功！");
                            this.getAnalysusDetailPageListBySet();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    });
                }
            })
        } else {
            this.$message.error("请选择需要删除的数据");
        }
    },
    /* 新增/编辑 */
    /* 表格 */
    sortchange(data) {
      this.sort = data.prop;
      this.order = data.order == "ascending" ? "asc" : "desc";
      this.getAnalysusDetailPageListBySet();
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.getAnalysusDetailPageListBySet();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.getAnalysusDetailPageListBySet();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getAnalysusDetailPageListBySet();
    },
    getAnalysusDetailPageListBySet() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.settingId = this.id;
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = this.sort;
      params.order = this.order;
      getAnalysusDetailPageListBySet(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },
    /* 表格 */
    /* 搜索筛选 */
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
    },
    /* 搜索筛选 */
    //返回
    forback() {
      this.$emit("forback", false);
    },
  },
};
</script>
<style scoped lang="less">
@import url('./index.less');
</style>
